import { render } from "./CapturaFoto.vue?vue&type=template&id=1b401980&scoped=true"
import script from "./CapturaFoto.vue?vue&type=script&lang=js"
export * from "./CapturaFoto.vue?vue&type=script&lang=js"

import "./CapturaFoto.vue?vue&type=style&index=0&id=1b401980&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b401980"]])

export default __exports__